export default __webpack_public_path__ + "static/media/GarlicKnots.b431ec23.jpg";